module.exports = __webpack_public_path__ + "media/stylesheets/images/sareye-8e7782f8018964ff4d6f4ba9451db3b6.svg";